import React from "react";
import { Link } from "react-router-dom";

// Animated coin logo (4 teal/white + 1 coral) — rolls in on load, then rests.
export const BrandMark = () => (
  <span className="auth-logo">
    <svg className="auth-coin-mark" viewBox="0 0 131.98 75.91" aria-hidden="true">
      <circle className="auth-coin" cx="16.9" cy="59.01" r="16.9" />
      <circle className="auth-coin" cx="41.09" cy="16.9" r="16.9" />
      <circle className="auth-coin" cx="65.99" cy="59.01" r="16.9" />
      <circle className="auth-coin" cx="89.47" cy="16.9" r="16.9" />
      <circle className="auth-coin auth-coin-accent" cx="115.08" cy="59.01" r="16.9" />
    </svg>
    <span className="auth-logo-word">moneyapp</span>
  </span>
);

// Left brand panel — reuses the landing story so auth feels part of the product.
const AuthBrand = ({ tagline }) => (
  <aside className="auth-brand">
    <span className="auth-brand-orb auth-brand-orb-1" />
    <span className="auth-brand-orb auth-brand-orb-2" />
    <Link to="/" className="auth-brand-logo" aria-label="MoneyApp home">
      <BrandMark />
    </Link>
    <div className="auth-brand-body">
      <h2>
        Quote, schedule, invoice — <span className="accent">get paid.</span>
      </h2>
      <p>{tagline}</p>
      <ul className="auth-points">
        <li><i className="fas fa-check-circle" /> Book jobs &amp; quote on site</li>
        <li><i className="fas fa-check-circle" /> Invoice and get paid faster</li>
        <li><i className="fas fa-check-circle" /> On your phone, the web — even offline</li>
      </ul>
    </div>
    <div className="auth-brand-foot">
      <i className="fas fa-shield-alt" /> 14-day free trial · No card required
    </div>
  </aside>
);

// Full-page frame: orb background + split shell (brand panel | form).
export const AuthFrame = ({ children, tagline }) => (
  <div className="auth">
    <span className="auth-orb auth-orb-1" />
    <span className="auth-orb auth-orb-2" />
    <span className="auth-orb auth-orb-3" />
    <div className="auth-shell">
      <AuthBrand tagline={tagline} />
      <main className="auth-main">{children}</main>
    </div>
  </div>
);

export default AuthBrand;
